import { gql } from '@apollo/client';

export const allConnectedBankingAccountsViaInternalPortalPaginatedGQL = gql`
    query allConnectedBankingAccountsViaInternalPortalPaginated(
        $page: Int!,
        $limit: Int!,
        $filters: ConnectedBankingFilterListing
    ) {
        allConnectedBankingAccountsViaInternalPortalPaginated(
            input: {
                filters: $filters,
                pagination: { page: $page, limit: $limit }
            }
        ) {
            items {
                id
                maskedAccountNo
                accountNo
                nickname
                balance
                balanceLastUpdatedAt
                validatedAt
                validationFailedAt
                notifyForTokenGeneration
                isQuickPayEnabled
                isPreferredForQuickPayUpi
                isPreferredForQuickPayBankTransfer
                authorization
            }
            meta {
                totalItems
            }
        }
    }
`;

export const connectedBankingAccountsViaInternalPortalByIdGQL = gql`
    query connectedBankingAccountsViaInternalPortalById(
        $bankAccountId: String!
    ) {
        connectedBankingAccountsViaInternalPortalById(
            bankAccountId: $bankAccountId
        ) {
            id
            maskedAccountNo
            accountNo
            nickname
            balance
            balanceLastUpdatedAt
            validatedAt
            validationFailedAt
            notifyForTokenGeneration
            isQuickPayEnabled
            isPreferredForQuickPayUpi
            isPreferredForQuickPayBankTransfer
            authorization
        }
    }
`;

export const toggleConnectedBankingQuickPayPreferenceForBankAccountGQL = gql`
    mutation toggleConnectedBankingQuickPayPreferenceForBankAccount(
        $bankAccountId: ID!,
        $isPreferredForQuickPayUpi: Boolean,
        $isPreferredForQuickPayBankTransfer: Boolean,
        $isQuickPayEnabled: Boolean,
    ) {
        toggleConnectedBankingQuickPayPreferenceForBankAccount(
            input: {
                bankAccountId: $bankAccountId,
                isQuickPayEnabled: $isQuickPayEnabled,
                isPreferredForQuickPayUpi: $isPreferredForQuickPayUpi,
                isPreferredForQuickPayBankTransfer: $isPreferredForQuickPayBankTransfer,
            }
        ) {
            success
            message
        }
    }
`;

export const verifyConnectedBankingBankAccountDetailsGQL = gql`
    mutation verifyConnectedBankingBankAccountDetails(
            $companyId: ID!,
            $accountNumber: String!,
            $ifsc: String!,
            $accountNameForValidation: String!,
            $bankIntegratorId: String!,
            $mobileNumber: String,
    ) {
        verifyConnectedBankingBankAccountDetails(
            input: {
                companyId: $companyId
                accountNumber: $accountNumber
                ifsc: $ifsc
                accountNameForValidation: $accountNameForValidation
                bankIntegratorId: $bankIntegratorId
                mobileNumber: $mobileNumber
            }
        ) {
            bankAccountValidationRequestId
            serviceProviderId
        }
    }
`;

export const initiateCorporateOnboardingRequestForTransBnkConnectedBankingGQL = gql`
    mutation initiateCorporateOnboardingRequestForTransBnkConnectedBanking(
        $companyId: ID!,
        $brandName: String!,
        $entityTypeId: String!,
        $businessTypeId: String!,
#        $natureOfBusiness: String,
        $bankAccountValidationRequestId: String!,
        $serviceProviderId: String!
    ) {
        initiateCorporateOnboardingRequestForTransBnkConnectedBanking(
            input:{
                companyId: $companyId
                nameOnBank: $brandName
                entityTypeId: $entityTypeId
                businessTypeId: $businessTypeId
                natureOfBusiness: "B2B"
                bankAccountValidationRequestId: $bankAccountValidationRequestId
                serviceProviderId: $serviceProviderId
                
            }
        )
    }
`;

export const initiateCorporateOnboardingRequestForEaseBuzzConnectedBankingGQL = gql`
    mutation initiateCorporateOnboardingRequestForEaseBuzzConnectedBanking(
        $companyId: ID!,
        $key: String!,
        $salt: String!,
        $nameOnBank: String!,
        $bankAccountValidationRequestId: String!,
        $serviceProviderId: String!
    ) {
        initiateCorporateOnboardingRequestForEaseBuzzConnectedBanking(
            input:{
                companyId: $companyId
                bankAccountValidationRequestId: $bankAccountValidationRequestId
                serviceProviderId: $serviceProviderId
                nameOnBank: $nameOnBank
                key: $key
                salt: $salt
                skipVaExistenceCheckAtEb: false
                isQuickPayEnabled: false
            }
        )
    }
`;

export const updateAndGrantCorporateOnboardingRequestForConnectedBankingGQL = gql `
    mutation updateAndGrantCorporateOnboardingRequestForConnectedBanking(
        $bankUserAuthorizationRequestId: String!,
        $brandName: String!,
        $entityTypeId: String!,
        $categoryType: String!,
        $businessTypeId: String!,
        $bankCode: String!,
        $debitAccNo: String!,
        $userId: String!,
        $corpId: String!,
        $entityId: String!,
        $programId: String!,
        $tokenNumber: String,
    ) {
        updateAndGrantCorporateOnboardingRequestForConnectedBanking(
            input:{
                bankUserAuthorizationRequestId: $bankUserAuthorizationRequestId
                credentials: {
                    entityTypeId: $entityTypeId
                    businessTypeId: $businessTypeId
                    natureOfBusiness: "B2B"
                    nameOnBank: $brandName
                    categoryType: $categoryType
                    bankCode: $bankCode
                    debitAccNo: $debitAccNo
                    userId: $userId
                    corpId: $corpId
                    tokenNumber: $tokenNumber
                }
                onboardingDataForCompany:{
                    entityId: $entityId
                    programId: $programId
                }
                isQuickPayEnabled: false
            }
        )
    }
`;

export const getSubMerchantEntityTypesForTransBnkGQL = gql`
    query getSubMerchantEntityTypesForTransBnk {
        getSubMerchantEntityTypesForTransBnk {
            id,
            description,
            key,
        }
    }
`;

export const getSubMerchantBusinessTypesForTransBnkGQL = gql`
    query getSubMerchantBusinessTypesForTransBnk {
        getSubMerchantBusinessTypesForTransBnk {
            id,
            description,
            key,
        }
    }
`

export const getConnectedBankingOnboardingRequestForCompanyGQL = gql`
    query getConnectedBankingOnboardingRequestForCompany(
        $companyId: ID!,
    ){
        getConnectedBankingOnboardingRequestForCompany(companyId: $companyId) {
            accounts {
                id
                maskedAccountNo
                nickname
                balanceLastUpdatedAt
                validatedAt
                validationFailedAt
                notifyForTokenGeneration
                bankName
            }
            pendingBankUserAuth {
                bankUserAuth {
                    id
                    status
                    bankIntegrationId
                    credentials {
                        nameOnBank
                        entityTypeId
                        categoryType
                        businessTypeId
                        natureOfBusiness
                        bankCode
                        debitAccNo
                        userId
                        corpId
                    }
                    bankAccountValidationRequest {
                        id
                        accountNumber
                        ifsc
                        bankName
                        accountNameForValidation
                    }
                }
                onboardingDataForCompany {
                    id
                    entityId
                    programId
                }
            }
        }
    }
`

export const getBankCodesByIntegrationIdGQL = gql`
    query getBankCodesByIntegrationId($integrationId: ID!) {
        getBankCodesByIntegrationId(integrationId: $integrationId)
    }
`;

export const rejectCorporateOnboardingRequestForConnectedBankingGQL = gql`
    mutation rejectCorporateOnboardingRequestForConnectedBanking(
        $bankUserAuthorizationRequestId: String!,
        $lastUpdateNotes: String!,
    ) {
        rejectCorporateOnboardingRequestForConnectedBanking(
            input: {
                bankUserAuthorizationRequestId: $bankUserAuthorizationRequestId,
                lastUpdateNotes: $lastUpdateNotes,
            }
        )
    }
`